module.exports = __webpack_public_path__ + "img/dubai.6205cc76.png";